import React from "react";
import { useSelector } from "react-redux";
import ErrorPage from "./Pages/ErrorPage";

const ProtectedRoute = ({ children, access = [], redirectTo = "/login" }) => {
  const { user, employeeLogin, organisationLogin, adminLogin } = useSelector(
    (state) => state.auth,
  );

  const userType = employeeLogin
    ? "employee"
    : organisationLogin
      ? "organisation"
      : adminLogin
        ? "admin"
        : null;

  // Allow sub-admins or management-view employees to access organisation routes
  const isSubAdmin = employeeLogin && user?.subAdmin?.isSubAdmin;
  const isManagementView =
    employeeLogin && user?.managementView?.isManagementView;
  const hasAccess =
    access.includes(userType) ||
    ((isSubAdmin || isManagementView) && access.includes("organisation"));

  if (!hasAccess) {
    return <ErrorPage status={403} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
